<template lang="pug">
	section#news-highlights
		.content
			header.header
				h2.title Comunicação
				p.subtitle As últimas notícias da sua cooperativa e do agronegócio
			//- Esqueleto com as medidas reais, para a seção não empurrar o layout quando a API responder
			.highlights.skeleton(v-if="loadingHighlights", aria-hidden="true")
				.featured
					.image
					.line.wide
					.line
				ul.side-list
					li.side-item(v-for="index in highlightsSize - 1", :key="index")
						.side-link
							.image
							.text
								.line
								.line.wide
			.error(v-else-if="highlightsFailed")
				p Não foi possível carregar as notícias.
				button.retry(type="button", @click="load") Tentar novamente
			.highlights(v-else-if="featured")
				router-link.featured(:to="newsRoute(featured)")
					.image
						img(v-if="featured.thumb", :src="featured.thumb", alt="", loading="lazy")
						FontAwesomeIcon.placeholder(v-else, :icon="icons.faImage")
					span.badge {{ featured.category }}
					h3.featured-title {{ featured.title }}
					p.description {{ featured.description }}
					.meta
						span.author Postado por Coamo
						span ·
						span {{ formatDate(featured.publishedAt) }}
				ul.side-list
					li.side-item(v-for="item in sideNews", :key="item.id")
						router-link.side-link(:to="newsRoute(item)")
							.image
								img(v-if="item.thumb", :src="item.thumb", alt="", loading="lazy")
								FontAwesomeIcon.placeholder(v-else, :icon="icons.faImage")
							.text
								span.category {{ item.category }}
								h3.side-title {{ item.title }}
			.tabs(role="group", aria-label="Editorias")
				button.tab(
					v-for="tab in tabs",
					:key="tab.key",
					type="button",
					:class="{ active: tab.key === activeTab }",
					:aria-pressed="String(tab.key === activeTab)",
					@click="selectTab(tab.key)"
				) {{ tab.label }}
			ul.grid.skeleton(v-if="loadingGrid && gridNews.length === 0", aria-hidden="true")
				li.card(v-for="index in gridSize", :key="index")
					.card-link
						.image
						.line
						.line.wide
			//- Na troca de aba a grade anterior fica esmaecida até a nova chegar
			ul.grid(v-else-if="gridNews.length > 0", :class="{ loading: loadingGrid }", :aria-busy="String(loadingGrid)")
				li.card(v-for="item in gridNews", :key="item.id")
					router-link.card-link(:to="newsRoute(item)")
						.image
							img(v-if="item.thumb", :src="item.thumb", alt="", loading="lazy")
							FontAwesomeIcon.placeholder(v-else, :icon="icons.faImage")
						span.tag {{ item.category }}
						h3.card-title {{ item.title }}
						span.date {{ formatDate(item.publishedAt) }}
			//- A falha dos destaques já mostra o erro acima
			.error(v-else-if="gridFailed && !highlightsFailed")
				p Não foi possível carregar as notícias.
				button.retry(type="button", @click="fetchGrid") Tentar novamente
			p.empty(v-else-if="showEmpty") Não foram encontrados resultados.
			.footer
				Link.all-news(:contents="contents.content")
					| Ver todas as notícias 
					FontAwesomeIcon.arrow(:icon="icons.faArrowRight")
</template>

<script>
import { faImage } from '@fortawesome/free-regular-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import Link from '@components/Link/Link'
import newsMixin, { ALL_TAB, DEFAULT_TABS } from '@/mixins/news'

const HIGHLIGHTS_SIZE = 6
const GRID_SIZE = 6

export default {
	name: "section-news-highlights",
	mixins: [ newsMixin ],
	props: {
		contents: {
			type: Object,
		}
	},
	components: {
		Link,
	},
	data() {
		return {
			icons: {
				faImage,
				faArrowRight,
			},
			tabs: DEFAULT_TABS,
			activeTab: ALL_TAB.key,
			highlightsSize: HIGHLIGHTS_SIZE,
			gridSize: GRID_SIZE,
			highlights: [],
			loadingHighlights: true,
			highlightsFailed: false,
			gridNews: [],
			loadingGrid: true,
			gridFailed: false,
			gridRequestId: 0,
		}
	},
	computed: {
		featured() {
			return this.highlights[0]
		},
		sideNews() {
			return this.highlights.slice(1)
		},
		// Em `Todas` com até 6 notícias a grade vem vazia, mas os destaques acima já as mostram
		showEmpty() {
			if (this.loadingGrid || this.gridFailed)
				return false
			return !(this.activeTab === ALL_TAB.key && this.featured)
		},
	},
	methods: {
		// Devolve `null` na falha, para diferenciar do resultado vazio
		fetchNews(skip, take, categoryId) {
			return this.$axios
				.get(`news/pagination`, { params: { skip, take, categoryId } })
				.then(response => this.parseNewsList(response.data.news))
				.catch(() => null)
		},
		fetchHighlights() {
			this.loadingHighlights = true
			this.fetchNews(0, HIGHLIGHTS_SIZE).then(news => {
				this.highlights = news || []
				this.highlightsFailed = !news
				this.loadingHighlights = false
			})
		},
		load() {
			this.fetchHighlights()
			this.fetchGrid()
		},
		// Em `Todas` a grade continua depois dos destaques; nas categorias começa do início
		fetchGrid() {
			const requestId = ++this.gridRequestId
			const skip = this.activeTab === ALL_TAB.key ? HIGHLIGHTS_SIZE : 0
			this.loadingGrid = true
			this.fetchNews(skip, GRID_SIZE, this.categoryParam(this.activeTab)).then(news => {
				// Descarta respostas de abas que já foram trocadas
				if (requestId !== this.gridRequestId)
					return
				this.gridNews = news || []
				this.gridFailed = !news
				this.loadingGrid = false
			})
		},
		selectTab(key) {
			if (key === this.activeTab)
				return
			this.activeTab = key
			this.fetchGrid()
		},
	},
	created() {
		this.fetchNewsTabs().then(tabs => {
			this.tabs = tabs
		})
		this.load()
	},
}
</script>

<style lang="stylus" scoped src="./NewsHighlightsSection.styl"></style>
